import React, { CSSProperties, ReactNode } from "react";
import styled from "styled-components";

interface TypographyProps {
  as?: "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: "xs" | "sm" | "md" | "lg";
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const StyledTypography = styled.p<TypographyProps>`
  margin: 0;
  padding: 0;
  font-size: ${({ size, theme }) => theme.fonts.sizes[size]};
`;

const Typography = ({ as = "p", children, ...rest }) => {
  return (
    <StyledTypography as={as} {...rest}>
      {children}
    </StyledTypography>
  );
};

export default Typography;
